import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { POPUP_NAME, MSG } from "../../utilities/constants";
import ModalLogin from "./ModalLogin";
import ModalInfo from "./ModalInfo";
import ModalVote from "./ModalVote";
import ModalNotify from "./ModalNotify";
import ModalLogout from "./ModalLogout";
import ModalToast from "./ModalToast";
import ModalNoTurnVote from "./ModalNoTurnVote";
import ModalIntroAds from "./ModalIntroAds";

const formatStrTime = (time) => {
  return time < 10 ? `0${time}` : time;
};

const parseTime = (time) => {
  const objDate = new Date(time);
  const timeDates = formatStrTime(objDate.getDate());
  const timeMonths = formatStrTime(objDate.getMonth() + 1);
  const timeYears = objDate.getFullYear();
  const timeHours = formatStrTime(objDate.getHours());
  const timeMinutes = formatStrTime(objDate.getMinutes());
  return `${timeHours}:${timeMinutes} ngày ${timeDates}/${timeMonths}/${timeYears}`;
};

const ModalHandler = () => {
  const popupName = useSelector((state) => state?.popup?.name || "");
  const campaignStartAt = useSelector((state) => state?.user?.campaignStartAt);
  const messageNotStart = useMemo(
    () => MSG.NOT_STARTED.replace("{{TIME_START}}", parseTime(campaignStartAt)),
    [campaignStartAt]
  );
  switch (popupName) {
    case POPUP_NAME.SHOW_NOT_STARTED:
      return <ModalToast message={messageNotStart} />;
    case POPUP_NAME.SHOW_ENDED:
      return <ModalToast message={MSG.ENDED} />;
    case POPUP_NAME.USER_VOTING:
      return <ModalVote />;
    case POPUP_NAME.INFO_RULE:
      return <ModalInfo />;
    case POPUP_NAME.LOGIN:
      return <ModalLogin />;
    case POPUP_NAME.LOGOUT:
      return <ModalLogout />;
    case POPUP_NAME.NOTIFY:
      return <ModalNotify />;
    case POPUP_NAME.NO_TURN_VOTING:
      return <ModalNoTurnVote />;
    case POPUP_NAME.INTRO_ADS:
      return <ModalIntroAds />;
    default:
      return null;
  }
};

export default React.memo(ModalHandler);
